import Vue from "vue";

Vue.prototype.$allacciaturames = [
  { key: "high_post_tom" },
  { key: "high_lat_tom" },
  { key: "high_med_tom" },
  { key: "start_lacing" }
];
